import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule as ngrxStoreModule } from '@ngrx/store';

import { CustomRouterStateSerializer } from './router/utils/router.util';
import { effects } from './store.effects';
import { reducers } from './store.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const devModules = [StoreDevtoolsModule.instrument({ maxAge: 50 })];

@NgModule({
  imports: [
    /**
     * StoreModule.forRoot is imported once in the root module, accepting a reducer
     * function or object map of reducer functions. If passed an object of
     * reducers, combineReducers will be run creating your application
     * meta-reducer. This returns all providers for an @ngrx/store
     * based application.
     */
    ngrxStoreModule.forRoot(reducers), // , { metaReducers } // FIXME: throwing an error when you open modal
    /**
     * EffectsModule.forRoot() is imported once in the root module and
     * sets up the effects class to be initialized immediately when the
     * application starts.
     *
     * See: https://github.com/ngrx/platform/blob/master/docs/effects/api.md#forroot
     */
    EffectsModule.forRoot(effects),
    /**
     * @ngrx/router-store keeps router state up-to-date in the store.
     */
    StoreRouterConnectingModule.forRoot({
      serializer: CustomRouterStateSerializer,
    }),
    ...devModules,
  ],
})
export class StoreModule {}
